import {DataTableSortStatus} from 'mantine-datatable';
import {SyntheticUser} from '../types';

// ⚠️ THE COMPARATOR NO LONGER LIVES HERE (FNP-912).
//
// `sortRecords` / `useTableSort` moved to `@flexinet/ui-components`, because the
// rules they encode — nulls last in BOTH directions, numeric vs string compare,
// empty-string-counts-as-missing — were being re-derived per table and usually
// got derived wrong. This module was the origin; it is now a consumer.
//
//     import {sortRecords} from '@flexinet/ui-components';
//
// What remains here is the one genuinely per-entity decision: WHICH key this
// table sorts by. How to compare two values is universal; what "newest" means
// for a SyntheticUser is not.

// DEFAULT: newest first, keyed on `bornAt`.
//
// WHY bornAt AND NOT created — both mean "when this user was created", but the
// schema types them differently:
//
//     bornAt:  AWSDateTime!   <- non-null, ALWAYS present
//     created: AWSDateTime    <- nullable
//
// A nullable default key degrades badly: rows missing it sort last (correctly),
// but if EVERY row lacks it the "sort" silently becomes insertion order, and the
// default ordering would then depend on page-arrival luck. bornAt cannot be
// absent, so the default is always meaningful. `created` is still sortable as a
// column like any other.
//
// This also agrees with the API's own order — listSyntheticUsers queries
// record-type-created-index with scanIndexForward: false — so the first paint
// matches the server rather than reshuffling it.
//
// Either key is immutable, which is what makes it safe: `updated` moves on every
// wake and would reorder the list under an operator who is reading it.
export const DEFAULT_SORT_STATUS: DataTableSortStatus<SyntheticUser> = {
    columnAccessor: 'bornAt',
    direction: 'desc'
};
